/** @file Name for a duplicated animation: `<base>-copy[-n]`, keeping the `@DIR` suffix. */
import { names } from '@pose2d/format/names';
import { slugifyName } from '@pose2d/format/slugifyName';

/** A name no animation in `taken` has: `walk` → `walk-copy`, then `walk-copy-2`; `run@SE` → `run-copy@SE`. */
export function copyName(name: string, taken: Iterable<string>): string {
  const { base, dir } = names.splitAnimation(name);
  const sameDir = [...taken].map((n) => names.splitAnimation(n)).filter((n) => n.dir === dir);
  const unique = slugifyName(`${base}-copy`, new Set(sameDir.map((n) => n.base)), 0).name;
  return dir === null ? unique : `${unique}@${dir}`;
}
